import { FC } from 'react';
import { convertCurrencyHexToChar } from 'shared/helpers/convertCurrencyHexToChar';

const Span: FC<{ hexCode: string }> = ({ hexCode }) => {
  const converted = convertCurrencyHexToChar(hexCode);
  return <span>{converted}</span>;
};

export default Span;
